export default "__VITE_ASSET__BKCGTlvQ__"